import React from 'react';
import AmCredentials from './AmCredentials';
import TgCredentials from './TgCredentials';
import WmCredentials from './WmCredentials';

class Credentials extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.selectedCred) return 'No selected instance.';
    const vendor = this.props.selectedCred.vendor;
    if (vendor === 'amazon') return <AmCredentials {...this.props} />;
    if (vendor === 'target') return <TgCredentials {...this.props} />;
    if (vendor === 'walmart') return <WmCredentials {...this.props} />;
    return 'This retailer is coming soon.';
  }
}

export default Credentials;
